import { useState, useEffect } from "react";

interface ImageDimensions {
  width: number;
  height: number;
  aspectRatio: number;
  isLoading: boolean;
  hasError: boolean;
}

export const useImageDimensions = (imageUrl: string | undefined): ImageDimensions => {
  const [dimensions, setDimensions] = useState<ImageDimensions>({
    width: 0,
    height: 0,
    aspectRatio: 1,
    isLoading: Boolean(imageUrl),
    hasError: false,
  });

  useEffect(() => {
    if (!imageUrl) {
      setDimensions({
        width: 0,
        height: 0,
        aspectRatio: 1,
        isLoading: false,
        hasError: false,
      });
      return;
    }

    setDimensions(prev => ({ ...prev, isLoading: true, hasError: false }));

    const img = new Image();
    
    img.onload = () => {
      // Calculate aspect ratio as height/width for consistent usage in card height calculation
      const aspectRatio = img.naturalHeight / img.naturalWidth;
      setDimensions({
        width: img.naturalWidth,
        height: img.naturalHeight,
        aspectRatio,
        isLoading: false,
        hasError: false,
      });
    };

    img.onerror = () => {
      setDimensions({
        width: 0,
        height: 0,
        aspectRatio: 1,
        isLoading: false,
        hasError: true,
      });
    };

    img.src = imageUrl;

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [imageUrl]);

  return dimensions;
}; 